import React from 'react';
import './WizardStep.css';
var WizardStep = function (props) {
    var _a = props.title, title = _a === void 0 ? '' : _a, id = props.id, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.error, error = _c === void 0 ? false : _c, children = props.children, className = props.className;
    var classes = ['tab-content', 'w-100'];
    if (disabled)
        classes.push('is-disabled');
    if (error)
        classes.push('text-danger');
    if (className)
        classes.push(className);
    return (React.createElement("div", { key: !!id ? id : title, className: classes.join(' ') }, children));
};
export default React.memo(WizardStep);
